import React from 'react';
import Layout from '../../components/layout/Layout';
import './terms.css';

const Terms = () => {
  return (
    <Layout>
      <div className="form-content">
        <div className="terms-container">
          <h1>Termos de Uso e Política de Privacidade - Fiz</h1>
          <p>
            Bem-vindo(a) à plataforma Fiz! Estes termos de uso e a política de privacidade descrevem os termos e condições que regem seu acesso e uso da plataforma Fiz, incluindo o site, aplicativos móveis e quaisquer outros serviços relacionados. Ao acessar ou utilizar a plataforma Fiz, você concorda com estes Termos e a Política de Privacidade. Se você não concorda com estes termos, não utilize a plataforma Fiz.
          </p>

          <h2>1. Termos de Uso</h2>

          <h3>1.1 Uso da Plataforma Fiz</h3>
          <p>
            A plataforma Fiz permite que você gerencie suas tarefas de forma eficiente, crie listas, defina prazos, adicione notas e acompanhe o progresso de suas atividades. Você se compromete a usar a plataforma Fiz de forma responsável e de acordo com estes Termos.
          </p>

          <h3>1.2 Conteúdo do Usuário</h3>
          <p>
            Você é o único responsável por qualquer conteúdo que você publica na plataforma Fiz, incluindo texto, imagens, vídeos e outros arquivos relacionados às suas tarefas. Você garante que possui todos os direitos necessários para publicar este conteúdo e que ele não viola os direitos de terceiros. Você concorda em não publicar conteúdo que seja ilegal, abusivo, difamatório, ameaçador, obsceno, racista, ou que viole de qualquer forma os direitos de terceiros.
          </p>

          <h3>1.3 Contas de Usuário</h3>
          <p>
            Você é responsável por manter a confidencialidade de sua conta e senha na plataforma Fiz. Você concorda em notificar a plataforma imediatamente de qualquer acesso não autorizado à sua conta ou de qualquer violação de segurança.
          </p>

          <h3>1.4 Suspensão e Encerramento de Contas</h3>
          <p>
            A plataforma Fiz se reserva o direito de suspender ou encerrar sua conta a qualquer momento, sem aviso prévio, se você violar estes Termos ou se a plataforma considerar que sua conta está sendo utilizada de forma inadequada.
          </p>

          <h2>2. Política de Privacidade</h2>

          <h3>2.1 Informações Coletadas</h3>
          <p>
            A plataforma Fiz coleta informações sobre você quando você cria uma conta, utiliza a plataforma, interage com seus recursos e comunica-se com a plataforma Fiz. Estas informações podem incluir seu nome, endereço de e-mail, senha, dados de atividade na plataforma Fiz, como tarefas criadas, prazos definidos e notas adicionadas, e informações sobre o dispositivo que você utiliza. A plataforma Fiz também pode coletar informações anônimas sobre o uso da plataforma por meio de cookies e outras tecnologias de rastreamento, como o tempo médio de uso, as funcionalidades mais acessadas e as páginas visitadas.
          </p>

          <h3>2.2 Uso das Informações</h3>
          <p>
            A plataforma Fiz utiliza as informações coletadas para fornecer e melhorar a plataforma Fiz, personalizar sua experiência, enviar comunicados sobre novas funcionalidades ou atualizações, fornecer suporte técnico, proteger a plataforma Fiz e cumprir com as leis aplicáveis.
          </p>

          <h3>2.3 Compartilhamento de Informações</h3>
          <p>
            A plataforma Fiz não compartilha suas informações pessoais com terceiros, exceto: (1) para fornecer os serviços da plataforma Fiz, como enviar notificações sobre tarefas vencidas; (2) para cumprir com as leis aplicáveis, caso seja necessário por ordem judicial; (3) para proteger os direitos e a segurança da plataforma Fiz e de seus usuários, caso haja suspeita de atividade ilegal ou prejudicial; ou (4) com seu consentimento explícito, caso você opte por compartilhar seus dados com outras plataformas.
          </p>

          <h3>2.4 Segurança das Informações</h3>
          <p>
            A plataforma Fiz utiliza medidas de segurança razoáveis para proteger suas informações pessoais contra acesso não autorizado, uso, divulgação, alteração ou destruição. No entanto, nenhuma transmissão de dados pela internet ou sistema de armazenamento de dados é totalmente seguro. Você reconhece que não podemos garantir a segurança absoluta de suas informações. Caso haja alguma suspeita de violação de segurança, notificaremos você imediatamente.
          </p>

          <h3>2.5 Cookies</h3>
          <p>
            A plataforma Fiz utiliza cookies para melhorar a experiência do usuário, fornecer funcionalidades e coletar informações sobre o uso da plataforma. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar sua capacidade de utilizar algumas funcionalidades da plataforma Fiz.
          </p>

          <h2>3. Modificações dos Termos</h2>

          <p>
            A plataforma Fiz se reserva o direito de modificar estes Termos a qualquer momento, a seu critério. Se fizermos alterações significativas, notificaremos você por e-mail ou por meio da plataforma Fiz. Você é responsável por verificar periodicamente os Termos para quaisquer atualizações.
          </p>

          <h2>4. Lei Aplicável e Jurisdição</h2>

          <p>
            Estes Termos serão regidos e interpretados de acordo com as leis de Fortaleza-CE/Brasil. Você concorda em se submeter à jurisdição exclusiva dos tribunais de Fortaleza-CE/Brasil para quaisquer disputas relacionadas a estes Termos.
          </p>

          <h2>5. Contato</h2>

          <p>
            Se você tiver alguma dúvida sobre estes Termos ou sobre a Política de Privacidade da plataforma Fiz, entre em contato com a plataforma por meio de [endereço de e-mail ou formulário de contato].
          </p>

          <p>Última atualização: 03 de Junho de 2024</p>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;